import { render, staticRenderFns } from "./ReminderComponent.vue?vue&type=template&id=076fadb0&"
import script from "./ReminderComponent.vue?vue&type=script&lang=js&"
export * from "./ReminderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports